<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<template>
  <b-table
    responsive
    stacked="sm"
    no-border-collapse
    small
    hover
    :items="items"
    :fields="fields"
  >
    <template
      #cell(origin)="{
        item: {
          origin: { type, city_name },
        },
      }"
    >
      <p>{{ type }}</p>
      <p>{{ city_name }}</p>
    </template>
    <template
      #cell(destination)="{
        item: {
          destination: { type, city_name },
        },
      }"
    >
      <p>{{ type }}</p>
      <p>{{ city_name }}</p>
    </template>
    <!-- <template #cell(gestion)="{ item: { id, license_id, state_ticket } }">
      <span
        v-if="state_ticket"
        class="cursor-pointer"
        @click.prevent="management({ id, license_id })"
      >
        <img
          alt="state"
          v-if="state_ticket !== 'not_available'"
          :src="
            require(`@/assets/modules/permisos-sindicales/icons/${state_ticket}.svg`)
          "
        />
      </span>
    </template> -->
  </b-table>
</template>

<style lang="scss" src="./styles.scss" />
